<template>
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.679 39.5565C33.3346 39.5565 40.3581 32.5329 40.3581 23.8774C40.3581 15.2219 33.3443 8.19836 24.679 8.19836C16.0138 8.19836 9 15.2122 9 23.8774C9 32.5427 16.0235 39.5565 24.679 39.5565Z"
      fill="#E7EEF1"
    />
    <path
      d="M39.3086 5.87656H36.336L36.1223 5.54627C35.8794 5.16741 35.2382 4.5554 34.4222 4.66226L33.9462 4.72054L33.7034 4.30282C33.4119 3.79768 32.8096 3.25367 32.0131 3.25367C30.9153 3.25367 30.0605 4.27368 30.0508 5.14798V5.86684H23.0078V4.40968H28.681C29.0502 2.95252 30.449 1.79651 32.0034 1.79651C33.0428 1.79651 34.0434 2.32109 34.704 3.18567C35.724 3.22453 36.5594 3.78796 37.084 4.40968H39.2989V5.86684L39.3086 5.87656Z"
      fill="#A2A9B1"
    />
    <path
      d="M21.3964 4.06975H19.2398L19.0164 3.77832C18.8804 3.59375 18.4918 3.27317 18.0158 3.32174L17.5689 3.37031L17.326 3.00117C17.1512 2.73888 16.8015 2.45716 16.3255 2.45716C15.694 2.45716 15.1889 2.94288 15.1889 3.35089V4.06975H10.0791V2.61259H13.8774C14.2369 1.69944 15.2374 1 16.3352 1C17.0735 1 17.7923 1.32058 18.2975 1.86458C18.9872 1.91315 19.5506 2.24344 19.9392 2.61259H21.4061V4.06975H21.3964Z"
      fill="#A2A9B1"
    />
    <path
      d="M18.6944 17.8447H30.1088C33.5769 17.8447 36.394 20.6619 36.394 24.1299V39.5078C36.394 40.965 35.2186 42.1404 33.7614 42.1404H15.6052C14.148 42.1404 12.9629 40.9553 12.9629 39.4981V23.5762C12.9629 20.4093 15.5275 17.8447 18.6944 17.8447V17.8447Z"
      fill="#6BFFFF"
    />
    <path
      d="M33.7615 42.8593H15.6053C13.7498 42.8593 12.2344 41.3535 12.2344 39.4981V23.5762C12.2344 20.011 15.1293 17.1161 18.6945 17.1161H30.1089C33.9752 17.1161 37.1227 20.2636 37.1227 24.1299V39.5078C37.1227 41.3632 35.6169 42.869 33.7615 42.869V42.8593ZM18.6945 18.5732C15.9356 18.5732 13.6915 20.8173 13.6915 23.5762V39.4981C13.6915 40.5472 14.5464 41.4021 15.6053 41.4021H33.7615C34.8106 41.4021 35.6655 40.5472 35.6655 39.4981V24.1202C35.6655 21.0601 33.1689 18.5635 30.1089 18.5635H18.6945V18.5732Z"
      fill="black"
    />
    <path
      d="M21.6481 13.2303H27.7196C27.7196 13.2303 27.7779 13.2789 27.7682 13.3081L26.1168 17.6115C26.1168 17.6115 26.0876 17.6504 26.0682 17.6504L23.0761 17.6698C23.0761 17.6698 23.0276 17.6504 23.0276 17.631L21.5898 13.2983C21.5898 13.2983 21.6093 13.2303 21.6384 13.2401L21.6481 13.2303Z"
      fill="#6BFFFF"
    />
    <path
      d="M22.5124 18.3985L22.3278 17.7962L20.793 13.1236L21.2787 12.5018H21.6576H28.1079L28.5742 13.1236L28.4673 13.5121L26.641 18.3208L26.0776 18.3596L22.5124 18.379V18.3985ZM22.561 13.9687L23.5907 16.9413H25.5919L26.777 13.9687H22.561V13.9687Z"
      fill="black"
    />
    <path
      d="M32.7133 41.4022L17.3937 41.4799L11.8564 50.6406L37.3859 51.0001L32.7133 41.4022V41.4022ZM18.2097 42.9371L31.8001 42.8594L33.1698 45.6766H16.5485L18.2097 42.9371ZM15.7325 47.0269V47.1337H33.879L35.035 49.504L14.4113 49.2126L15.7422 47.0171L15.7325 47.0269Z"
      fill="black"
    />
    <path
      d="M16.8975 25.5192C16.8975 24.4506 17.7718 23.5763 18.8403 23.5763H24.5621V31.241H18.8403C17.7718 31.241 16.8975 30.3667 16.8975 29.2981V25.5192V25.5192Z"
      fill="white"
    />
    <path
      d="M32.9264 25.5192C32.9264 24.4506 32.0521 23.5763 30.9835 23.5763H25.2617V31.241H30.9835C32.0521 31.241 32.9264 30.3667 32.9264 29.2981V25.5192Z"
      fill="white"
    />
    <path
      d="M18.6076 32.0764C17.1893 32.0764 16.043 30.9204 16.043 29.5118V25.286C16.043 23.8677 17.199 22.7214 18.6076 22.7214H31.7609C33.1792 22.7214 34.3255 23.8774 34.3255 25.286V29.5118C34.3255 30.9301 33.1695 32.0764 31.7609 32.0764H18.6076V32.0764ZM26.0099 30.697H31.7512C32.4117 30.697 32.9363 30.1627 32.9363 29.5118V25.286C32.9363 24.6255 32.402 24.1009 31.7512 24.1009H26.0099V30.697ZM18.6076 24.1009C17.947 24.1009 17.4224 24.6352 17.4224 25.286V29.5118C17.4224 30.1724 17.9567 30.697 18.6076 30.697H24.5916V24.1009H18.6076Z"
      fill="black"
    />
    <path
      d="M30.9839 38.7891C32.0569 38.7891 32.9268 37.9192 32.9268 36.8462C32.9268 35.7732 32.0569 34.9033 30.9839 34.9033C29.9109 34.9033 29.041 35.7732 29.041 36.8462C29.041 37.9192 29.9109 38.7891 30.9839 38.7891Z"
      fill="white"
      stroke="black"
      stroke-miterlimit="10"
    />
    <path
      d="M17.9761 38.7891C19.0491 38.7891 19.919 37.9192 19.919 36.8462C19.919 35.7732 19.0491 34.9033 17.9761 34.9033C16.9031 34.9033 16.0332 35.7732 16.0332 36.8462C16.0332 37.9192 16.9031 38.7891 17.9761 38.7891Z"
      fill="white"
      stroke="black"
      stroke-miterlimit="10"
    />
  </svg>
</template>
